// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__24DSX","col":"CardReaderDesc_col__2BB0Y","label":"CardReaderDesc_label__1Ix-D"};